module.exports = __webpack_public_path__ + "static/media/g.676207ad.png";